import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {
  getAddressBook,
} from '../../actions/addressBook';
import {doCall} from '../../actions/call';
import moment from 'moment-timezone';
import orderBy from 'lodash/orderBy';
import Loader from '../Components/Loader';
import 'react-select/dist/react-select.min.css';
import { logData, keyDownHandler, pasteHandler } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

class AddressBook extends Component {

  constructor(props) {
    super(props);
    this.state = {
			isShow: false,
      showErr: false,
			showAddressBook:props.showAddressBook,
      perPage: 100,
      activePage: 1,
      callsData: this.props.callsData,
      displayingCalls: [],
      displayingCallsAll: [],
      loading: false,
      totalData: 100,
		};
  }
  // checks if date is valid
  validDate = (current) => {
      return current.isBefore( this.state.yesterday );
  };

  // handleSelect = (eventKey) => {
  //   this.setState({
  //     activePage: eventKey,
  //     loading: true,
  //   }, () => {
  //     this.getCallsData();
  //   });
  // }

  /**
   * makes all filters empty and update state with new values.
   * gets contact list
   */
  handleEnter = () => {
    const colFilters = {};
    this.props.columns.forEach(col => {
      if(col.filter){
        colFilters[col.key] = '';
      }
    });
    this.setState({
      loading: true,
      ...colFilters
    }, () => {
      this.getAddressBookData();
    });
  }

  getAddressBookData = () => {
    this.setState({
      loading: true,
      displayingCalls: [], // Initialize the displayingCalls state to an empty array
    }, () => {
        this.props.getAddressBook(200, (items) => { // Call getAddressBook with a callback function
        const mappedCalls = items.map(item => {
          const newItem = { ...item }; // create a copy of the item object
          this.props.columns.forEach(col => {
            if (col.isArray && newItem[col.key]) {
              newItem[`${col.key}Array`] = newItem[col.key]; // create a new array property
              newItem[col.key] = newItem[col.key].map(data => data[col.childKey]); // extract child properties into new array
            }
          });
          return newItem; // return the modified item object
        });
        this.setState({
          loading: false,
          // Add the fetched items to the displayingCalls state
          displayingCalls: [...this.state.displayingCalls, ...mappedCalls], 
          // Add the fetched items to the displayingCallsAll state
          displayingCallsAll: [...this.state.displayingCallsAll, ...mappedCalls], 
          paginationItems: Math.round(this.state.totalData / this.state.perPage),
          appliedTimezone: this.state.selectedTimezone
        });
      });
    });
  }
  // makes an outgoing call
  makeCall = (e) => {
    const payload = {
			phoneNumber: e.target.id
		};
		this.props.doCall(payload);
	}

  /**
   * Gets value that needs to be displayed for table column.
   * compares for different column types.
   * @param  {object} item contact data
   * @param  {object} col  column data
   * @return {string}      value that needs to be displayed
   */
  getColumnValue = (item, col) => {
    let value = item[col.key];
    if(col.time){
      value = moment.tz(item[col.key] * 1000, this.state.appliedTimezone).format('DD-MM-YYYY HH:mm');
    }
    if(col.operation === 'subtract'){
      if(item[col.firstItem] !== null && item[col.secondItem] !== null){
        value = item[col.firstItem] - item[col.secondItem];
      }else{
        value = '';
      }
    }
    if(col.isArray){
      value = item[`${col.key}Array`].map(data => {
        const extraAtrr = col.doCall ? {
          onClick: this.makeCall,
          id: data[col.childKey],
          className: 'cursor'
        } : {};
        return (
        <span
          key={ data[col.childKey] }
          {...extraAtrr}
          >
            {data[col.childKey]}<br />
          </span>
      )});
    }
    return value;
  }
  // renders list of contacts. loops through list data and columns
  renderContacts = () => {
    return this.state.displayingCalls.map((item, index) => {
      return (
        <tr key={index}>
          {this.props.columns.map((col) => {
            return (
              <td
                style={ {...col.style, wordBreak: 'break-all'} }
                key={col.key}
              >
                { this.getColumnValue(item, col) }
              </td>
            )
          })}
        </tr>
      );
    });
  }
  
  // render header for table
  renderHeader = () => {
    return this.props.columns.map((item, key) => {
      return (
        <th
          style={ {...item.style, position: 'relative', cursor: 'pointer'} }
          key={key}
          id={ item.key }
          onClick={ this.handleSort }
        >
          {item.title.length>0 ? this.props.translations[item.title][this.props.selectedLanguage] : ''}
          {this.state[`${item.key}Sort`] && <span
            className={ this.state[`${item.key}Sort`] == 'desc' ? 'headerSortUp' : 'headerSortDown' }
            style={ {color: 'rgba(0, 0, 0, 0.5)', position: 'absolute', right: '20px'} }
            aria-hidden="true"
            id={ item.key }
            onClick={ this.handleSort }
          />}
        </th>
      );
    });
  }
  // shows filters for columns where it needs to be added
  renderFilters = () => {
    return this.props.columns.map((item, key) => {
      return (
        <td
          style={ {...item.style} }
          key={key}
          id={ item.key }
        >
          {item.filter &&
            <input
              type="text"
              className={`form-control${this.props.theme} input-sm${this.props.theme}`}
              id={ item.key }
              onKeyDown={item.title === "phoneNumber" ? 
                (event) => keyDownHandler(event, "allowNumbersAndChars") : 
                ""
              }
              onPaste={
                item.title === "phoneNumber" ? 
                (event) => pasteHandler(event, "allowNumbersAndChars") : 
                ""
              }
              onChange={ this.handleCallsFilterChange }
            />
          }
        </td>
      );
    });
  }
  // handles sorting of table
  handleSort = (e) => {
    const sortType = this.state[`${e.target.id}Sort`] == 'desc' ? 'asc' : 'desc';
    const orderedData = orderBy(this.state.displayingCalls, e.target.id, sortType);
    const orderedDataAll = orderBy(this.state.displayingCallsAll, e.target.id, sortType);
    this.setState({
      [`${e.target.id}Sort`]: sortType,
      displayingCalls: orderedData,
      displayingCallsAll: orderedDataAll,
    });
  }
  // filters data
  handleCallsFilterChange = (e) => {
    const key = e.target.id;
    const filterValue = e.target.value;
    this.setState({
      [key]: filterValue
    }, () => {
      //NOTE - 
      //For every column we iterate the list. On some columns the items are arrays
      let filteredList = this.state.displayingCallsAll;
      this.props.columns.forEach(col => {
        if(col.filter){
          filteredList = filteredList.filter(item => {
            let itemValue = item[col.key];
            //NOTE - 
            //We convert the array into a string so we can convert it to lowercase
            if (col.isArray){
              itemValue = item[col.key].toString()
            }
            return itemValue.toLowerCase().includes(this.state[col.key].toLowerCase());
          });
        }
      });
      
      this.setState({
        displayingCalls: filteredList
      });
    })
  }

  close = (key) => {
    this.setState({
      showErr: false
    }, () => {
      this.props.handleClose(key);
    });
  }

  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }

  render(){
    const {
      translations, selectedLanguage
    } = this.props;
    return (
      <Modal
        dialogClassName="extraLarge"
        bsSize="lg"
        onEnter={this.handleEnter}
        show={this.props.showAddressBook}
        onHide={() => this.close('showAddressBook')}
        backdrop="static"
      >
        <Modal.Header className={`modal-content1${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{this.props.headerText}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content1${this.props.theme}`} style={ { maxHeight: '100%' } }>
          {this.state.showErr && <div className="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          <div className="table-responsive">
						<table className={`table-fixed table table${this.props.theme} table-hover${this.props.theme} m-a-0`}data-sort="table">
							<thead>
								<tr>
									{this.renderHeader()}
								</tr>
                <tr>
									{this.renderFilters()}
								</tr>
							</thead>
              <tbody style={{maxHeight: 300, minHeight: 300, paddingRight: 17}}>
								{this.renderContacts()}
                {(!this.state.loading && this.state.displayingCalls.length == 0) &&
                  <h3 style={ {textAlign: 'center'} }>{translations.noContactFound[selectedLanguage]}</h3>
                }
                {this.state.loading && <h3><Loader width="20px" height="20px" /></h3>}
							</tbody>
						</table>
					</div>
        </Modal.Body>
        <Modal.Footer className={`modal-content1${this.props.theme}`}>
          <nav className="text-center">
          {/* <Pagination
          bsSize="sm"
          items={this.state.paginationItems}
          activePage={this.state.activePage}
          onSelect={this.handleSelect} /> */}
          </nav>
        <br />
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        outgoingCalls: state.outgoingCalls,
        agentInfo: state.agentInfo,
        translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
        addressBook: state.addressBook,
    };
}

const mapDispatchToProps = {
  getAddressBook,
  doCall
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressBook);



// WEBPACK FOOTER //
// ./src/agent/modals/AddressBook.js